import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getState } from "@bd-stores/store";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    saveFinalRoomAnswers,
    setMiddleState,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomMatchCard extends BD_Component {
    constructor() {
        super();

        this.id = "match_card";
        this.templateID = "match_card-template";
        this.elms = {
            blur: ".app-blur",
            matchCardItem: ".js-matchCard-item",
            matchCardAnswerBtn: ".js-matchCard-answer",
            matchCardClearAnswerBtn: ".js-matchCard-clear-answer",
            matchCardSelectBtn: ".js-matchCard-select",
            matchCardAudioBtn: ".js-matchCard-audio",
            matchOverlay: ".js-matchCard-overlay",
            matchOverlayClose: ".js-matchOverlay-close",
            slotAnswerImage: ".js-match-answer-image",
            submitBtn: ".js-submit",
            check: ".check__result",
        };

        this._events = this.getEvents();

        /**
         * @type {Array<HTMLAudioElement>}
         */
        this.audios = [];

        /**
         * @type {BD_RoomMatchCards}
         */
        this._data = undefined;

        this.userAnswer = undefined;

        this.useMiddleState = true;

        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmitAnswer,
            },
            {
                event: "click",
                selector: elms.matchCardAudioBtn,
                handler: this.onPlayAudio,
            },
            {
                event: "click",
                selector: `${elms.matchCardAnswerBtn}, ${elms.matchOverlayClose}`,
                handler: this.onToggleMatchOverlay,
            },
            {
                event: "click",
                selector: elms.matchCardSelectBtn,
                handler: this.onSelectCard,
            },
            {
                event: "click",
                selector: elms.matchCardClearAnswerBtn,
                handler: this.onClearAnswer,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.registerSounds();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const hotspots = modified.hotspots;

        // if `default_image` is not set in the admin, we will use this fallback image
        const fallbackDefaultImage = `${CONFIG.themeURL}/assets/images/matchcard-placeholder.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/matchcards-new.png`;

        const slotsWithDefaultImage = this._data.slots.map((s) => ({
            ...s,
            default_image: s.default_image
                ? s.default_image
                : fallbackDefaultImage,
        }));

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const puzzleHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "puzzle",
        );

        const slots = bdjs.splitArrayToBulks(slotsWithDefaultImage, 4);
        const newSlots = slots.map((slot, i) => {
            if (puzzleHotspots.length < 1) return slot;

            if (hotspots[i]["hotspot_type"] === "puzzle") {
                let hotspot = { ...hotspots[i] };
                return {
                    ...slot,
                    position_top: hotspot["position_top"],
                    position_left: hotspot["position_left"],
                };
            }
        });

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const newHints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: newHints,
            slots: newSlots,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);

        $(".app").html(html);

        if (isForcedOpenChallenge) {
            // this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);
        const elms = this.elms;
        let isMiddleState = false;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (roomAnswers) {
            $.each(roomAnswers, this.setViewAnswer.bind(this));

            isMiddleState = Object.values(roomAnswers).find(
                (value) => value.isMiddleState === true,
            )
                ? true
                : isMiddleState;

            if (thisRoomStatus == "is-status-completed") {
                if (!this.meSubmittingAnswer)
                    $(elms.check).removeClass("is-shown");

                $(elms.submitBtn).parent().parent().addClass("is-completed");
                $(".app__page").addClass("is-room-completed");

                /* Show completion popup */
                this.completionPopup.show(roomId, isMiddleState, roomAnswers);
            }
        }

        getRoomAnswers(roomId).then((data) => {
            this.updateUserChoicesList(data);
        });
    }

    // ============================== CUSTOM FUNCTION
    registerSounds() {
        const elms = this.elms;
        const self = this;

        if (this.audios.length) {
            return false;
        }

        const $elBtnAudios = $(elms.matchCardAudioBtn);

        $.each($elBtnAudios, function (index, elBtnAudio) {
            const $audio = $(elBtnAudio);
            const audioUrl = $audio.attr("data-audio");
            const id = $audio.parents(elms.matchCardItem).attr("data-key");
            if (audioUrl) {
                const audio = new Audio(audioUrl);
                audio.id = id;
                self.audios.push(audio);
            }
        });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     * @returns {Boolean}
     */
    toggleCheckButton() {
        const elms = this.elms;
        let isAnsweredAll = true;

        if ($(elms.submitBtn).hasClass("is-completed")) return false;

        $(elms.matchCardItem).each(function () {
            const isThisAnswered = $(this).hasClass("is-filled");
            if (!isThisAnswered) return (isAnsweredAll = false);
        });

        $(elms.submitBtn).prop("disabled", !isAnsweredAll);
        return isAnsweredAll;
    }

    onToggleMatchOverlay(e, el) {
        const elms = this.elms;
        const $matchOverlay = $(elms.matchOverlay);
        const isOpen = $(elms.matchOverlay).hasClass("is-open");

        $matchOverlay.toggleClass("is-open", !isOpen);

        if (!isOpen) {
            const $matchcard = $(el).parents(elms.matchCardItem);
            const key = $matchcard.attr("data-key");
            $matchOverlay.attr("data-active-key", key);
            $matchOverlay
                .find(".matchCards__options--item")
                .removeClass("active");
            $matchOverlay
                .find(
                    '.matchCards__options--item[data-active-key="' + key + '"',
                )
                .addClass("active");

            $(elms.blur).addClass("is-blurred");
            $(".timer").addClass("is-top");
        } else {
            $(elms.blur).removeClass("is-blurred");
            $(".timer").removeClass("is-top");
        }
    }

    onSubmitAnswer(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const $result = $el.siblings(".challenge__result");
        const sttCompleted = "is-status-completed";

        if (
            $el.hasClass("is-loading") ||
            $el.hasClass("is-completed") ||
            sttCompleted === getRoomStatus(this.roomId)
        ) {
            return;
        }

        $result.removeClass("is-shown");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        const $matchCardItems = $(elms.matchCardItem);
        const roomAnswers = getRoomAnswerById(roomID);
        const isUsingMiddleState = this._data.isUseMiddleState;

        let roomStatus = "is-status-started";
        let playerAnswers = {};
        let correct = 0;
        let middle = 0;
        let wrong = 0;
        let isMiddleState = false;

        $.each($matchCardItems, function (index, item) {
            const $item = $(item);
            const cardId = $item.attr("data-key");
            const answer = $item.attr("data-answer");

            playerAnswers[cardId] = {
                answer: answer,
                isMiddleState: false,
            };
        });

        for (const key in playerAnswers) {
            const playerAnswer = playerAnswers[key].answer;
            const correctAnswers = roomAnswers?.[key]?.correct || [];
            const middleAnswers = roomAnswers?.[key]?.middle || [];

            if (correctAnswers.includes(playerAnswer)) {
                correct++;
            } else if (
                isUsingMiddleState &&
                middleAnswers.includes(playerAnswer)
            ) {
                middle++;
                isMiddleState = true;
                playerAnswers[key].isMiddleState = true;
            } else {
                wrong++;
            }
        }

        const isAllCorrect = wrong == 0 && (correct > 0 || middle > 0);

        $result.addClass("is-shown");

        $result.find(".result--correct span.count").text(correct);
        $result.find(".result--middle span.count").text(middle);
        $result.find(".result--wrong span.count").text(wrong);

        $el.removeClass("is-loading").removeAttr("disabled");

        if (isAllCorrect) {
            roomStatus = sttCompleted;
            this.meSubmittingAnswer = true; // a flag to set the UI state

            if (isMiddleState) setMiddleState(roomID);

            const onSuccess = () => {
                $el.parent().parent().addClass("is-completed");
                $(".app__page").addClass("is-room-completed");
            };

            saveFinalRoomAnswers(roomID, playerAnswers)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    onPlayAudio(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const id = $el.parents(elms.matchCardItem).attr("data-key");

        this.playPauseAudio(id, el);
    }

    playPauseAudio(id, btnEl = null) {
        /** @type {HTMLAudioElement | undefined} */
        let theAudio;

        const elms = this.elms;
        const $matchCardItem = btnEl
            ? $(btnEl).parents(elms.matchCardItem)
            : false;

        $.each(this.audios, function (index, audio) {
            if (audio.id == id) {
                theAudio = audio;
            } else {
                if (!audio.paused) {
                    try {
                        audio.pause();
                        $(elms.matchCardItem).removeClass("is-playing");
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        });

        if (theAudio) {
            try {
                if (!theAudio.paused) {
                    theAudio.pause();
                    if ($matchCardItem)
                        $matchCardItem.removeClass("is-playing");

                    GameLogic.backgroundAudio.play();
                } else {
                    theAudio.play();

                    GameLogic.backgroundAudio.pause();

                    if ($matchCardItem) {
                        $(theAudio).on("ended", function () {
                            $matchCardItem.removeClass("is-playing");
                        });

                        $matchCardItem.addClass("is-playing");
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    onSelectCard(e, el) {
        const elms = this.elms;
        const $el = $(el);

        const $matchoverlay = $el.parents(elms.matchOverlay);
        const key = $matchoverlay.attr("data-active-key");
        const chosenId = $el.attr("data-id");
        const isChosenMultiple = $el.attr("data-chosen-multiple") ?? false;
        const isSelected = $el.hasClass("is-selected");
        const hasSelected = !isSelected;

        const $sameCards = $(
            elms.matchCardItem + `.is-filled[data-answer="${chosenId}"]`,
        );

        if ($sameCards.length) {
            if (!isChosenMultiple) {
                $sameCards
                    .removeAttr("data-answer")
                    .removeClass("is-filled")
                    .find(elms.slotAnswerImage)
                    .removeAttr("src");
            }
        }

        this.setViewAnswer(key, chosenId);

        $el.toggleClass("is-selected", hasSelected);
        $matchoverlay.removeClass("is-open");
        $(elms.blur).removeClass("is-blurred");
        $(".timer").removeClass("is-top");

        const answerData = {
            [key]: chosenId,
        };

        this.userAnswer = answerData;

        this.updateUserAnswer();

        this.toggleCheckButton();
    }

    setViewAnswer(key, answerValue) {
        const elms = this.elms;
        const $cardItem = $(elms.matchCardItem + `[data-key="${key}"]`);
        const theAnswer = answerValue?.answer || answerValue;
        const $answer = $(elms.matchCardSelectBtn + `[data-id="${theAnswer}"]`);
        const imageURL = $answer.attr("data-image");

        $cardItem.find(elms.slotAnswerImage).prop("src", imageURL);

        $cardItem.addClass("is-filled");
        $cardItem.attr("data-answer", theAnswer);
        this.toggleCheckButton();
    }

    onClearAnswer(e, el) {
        const elms = this.elms;
        const $matchcard = $(el).parents(elms.matchCardItem).first();
        const answerId = $matchcard.attr("data-answer");
        const $answer = $(elms.matchCardSelectBtn + `[data-id=${answerId}]`);

        $answer.removeClass("is-selected");

        $matchcard
            .removeClass("is-filled")
            .removeAttr("data-answer")
            .find(elms.slotAnswerImage)
            .removeAttr("src");

        this.dischardUserAnswer(answerId);

        this.toggleCheckButton();
    }

    beforeDestroy() {
        this.playPauseAudio(null);
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    dischardUserAnswer(answerId) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const userAns = fbRoomAnswers[currentPlayerId]?.choice;

            const userAnsw = Object.keys(userAns)
                .filter((answer) => {
                    return userAns[answer] != answerId;
                })
                .reduce((answ, key) => {
                    answ[key] = userAns[key];
                    return answ;
                }, {});

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: userAnsw,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const slotID = hasContext
                ? $context.attr("data-slot-id")
                : undefined;
            const slotChoiceID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[slotID] == slotChoiceID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
